export default __webpack_public_path__ + "static/ai-marketing-3-3cf0e8ebcc179e39599eee84021dc2c5.webp";